import { useEffect, useRef } from 'react';
function useCronometro(callback:any, delay:any) {
    const savedCallback = useRef() as any;
  
    // Recordar el callback actual.
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);
  
    // Configurar el intervalo.
    useEffect(() => {
      function tick() {
        savedCallback.current();
      }
  
      if (delay !== null) { // Solo configurar si el delay es válido
        const id = setInterval(tick, delay);
        return () => clearInterval(id); // Limpieza cuando se desmonta
      }
    }, [delay]);
  }

export default useCronometro;